/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { HistoricalBalancesDrawer } from "./HistoricalBalancesDrawer";
import { UserBalance } from "../../../service/api-response/UserBalanceSuccessResponse";

type Props = {
  balance: UserBalance;
};

export const HistoricalBalancesSelector = ({ balance }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary
        height="fit-content"
        onClick={() => {
          setModalOpen(true);
        }}
        type="button"
      >
        Top up balance history
      </ButtonPrimary>
      <HistoricalBalancesDrawer
        balance={balance}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};
